// extracted by mini-css-extract-plugin
export default {"home_container":"Home_home_container__wOs2R","home_top_content":"Home_home_top_content__kTTuP","home_text_container":"Home_home_text_container__Kr6tb"};